import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShopLike = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "shop-like" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M4.785.75a.962.962,0,0,0-.895.664L2.376,5.691A2.207,2.207,0,0,0,2.362,7.12,2.655,2.655,0,0,0,4.844,9,2.741,2.741,0,0,0,7.479,6.164,2.741,2.741,0,0,0,10.114,9,2.742,2.742,0,0,0,12.75,6.164,2.741,2.741,0,0,0,15.385,9a2.742,2.742,0,0,0,2.636-2.836A2.741,2.741,0,0,0,20.656,9a2.656,2.656,0,0,0,2.482-1.88,2.207,2.207,0,0,0-.014-1.429L21.61,1.414a.963.963,0,0,0-.9-.664Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: 12,
			x2: 3.75,
			y2: 8.744
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.75,8.744V19.5a1.5,1.5,0,0,1-1.5,1.5h-4.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M3.75,22.5a3.026,3.026,0,0,1,.779.115l1.817.519a2.98,2.98,0,0,0,.823.116H9.612a3,3,0,0,0,2.985-2.7L12.747,18a2.249,2.249,0,0,0-1.7-2.3l-.728-.16a.749.749,0,0,1-.568-.727V13.125a1.125,1.125,0,0,0-2.25,0V13.9a3.75,3.75,0,0,1-3.75,3.75Z"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "0.75 16.5 3.75 16.5 3.75 23.25 0.75 23.25"
		})
	]
});
export default SvgShopLike;
